import { registerModal } from 'features/Modal/ModalRegistry'
import CasesCreateBillingDisputeModal from './CasesCreateBillingDisputeModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'CASES_CREATE_BILLING_DISPUTE'
registerModal(modalType, CasesCreateBillingDisputeModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateBillingDisputeModal/CasesCreateBillingDisputeModal.action.js